export default {
  page_title:          'Conecte sua conta bancária',
  page_subtitle:       'Fique tranquilo! A conexão bancária é automática e segura. Vamos validar a sua renda e em seguida analisar o seu pedido de empréstimo.',
  subtitle_learn_more: 'Saiba mais',
  connect:             'Conectar',
  refuse_to_connect:   'Não quero conectar',
  warning_msg:         '<strong>Atenção: </strong>Optando por não conectar sua conta, não poderemos aprovar a sua solicitação de empréstimo.',
  bank_error:          'Tivemos um problema na conexão com seu banco. Por favor tente novamente mais tarde',
  phone_verification:  {
    title:        'Estamos quase lá',
    instructions: 'O próximo passo é a validação do seu número de telefone. É através dele que entraremos em contato com você, se necessário.',
  },
  skip_ebs_checkbox_label: 'Não quero conectar minha conta bancária agora e estou ciente que isso pode afetar as chances de aprovação.',
  skip_ebs_more_info: 'Ao conectar sua conta ao Simplic Express suas chances de aprovação aumentam. As suas informações estão seguras. É impossível realizarmos qualquer movimentação financeira em sua conta.'
};
